<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true}" (click)="toggleOpen()">
        <span class="margin-right">Documentation</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>

  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">Upload Cement Tickets:</span>
      @if (fieldHasNotes('documentation|cementTickets') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|cementTickets'" [notes]="getFilteredNotes('documentation|cementTickets')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'cementTickets'" [files]="cementTicketsFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="allowFileManipulation('cementTickets')" [allowUpload]="allowFileManipulation('cementTickets')" (fileRemoved)="cementTicketFileRemoved($event)" (newFilesList)="cementTicketFileAdded($event)"></upload-view-files>

    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">Cement Job Logs:</span>
      @if (fieldHasNotes('documentation|cementJobLogs') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|cementJobLogs'" [notes]="getFilteredNotes('documentation|cementJobLogs')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'cementJobLogs'" [allowDeletion]="allowFileManipulation('cementJobLogs')" [allowUpload]="allowFileManipulation('cementJobLogs')" [files]="cementJobLogsFiles" [componentLabel]="''" [showFileList]="true" (fileRemoved)="cementJobLogFileRemoved($event)" (newFilesList)="cementJobLogFileAdded($event)"></upload-view-files>
    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">Safety Data Sheet:</span>
      @if (fieldHasNotes('documentation|safetyDateSheet') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|safetyDateSheet'" [notes]="getFilteredNotes('documentation|safetyDateSheet')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'safetyDateSheet'" [allowDeletion]="allowFileManipulation('safetyDateSheet')" [allowUpload]="allowFileManipulation('safetyDateSheet')" [files]="safetyDateSheetFiles" [componentLabel]="''" [showFileList]="true" (fileRemoved)="safetyDateSheetFileRemoved($event)" (newFilesList)="safetyDateSheetFileAdded($event)"></upload-view-files>
    </div>
    <div class="cell small-12 medium-12 large-12 text-align-left">
      <span class="bold">Upload any other cement data:</span>
      @if (fieldHasNotes('documentation|cementData') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'documentation|cementData'" [notes]="getFilteredNotes('documentation|cementData')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
      <br />
      <upload-view-files [uniqueId]="'cementData'" [files]="cementDataFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="allowFileManipulation('cementData')" [allowUpload]="allowFileManipulation('cementData')" (fileRemoved)="cementDataFileRemoved($event)" (newFilesList)="cementDataFileAdded($event)"></upload-view-files>
    </div>


    @if (reportType?.typeId == 'F8F') {
      <div class="cell small-12 medium-12 large-12 text-align-left">
        <span class="bold">P-R Graph:</span>
        @if (fieldHasNotes('documentation|prGraph') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'documentation|prGraph'" [notes]="getFilteredNotes('documentation|prGraph')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
        <br />
        <upload-view-files [uniqueId]="'prGraph'" [files]="prGraphFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="allowFileManipulation('prGraph')" [allowUpload]="allowFileManipulation('prGraph')" (fileRemoved)="prGraphFileRemoved($event)" (newFilesList)="prGraphFileAdded($event)"></upload-view-files>
      </div>
      <div class="cell small-12 medium-12 large-12 text-align-left">
        <span class="bold">Stimulation Invoice:</span>
        @if (fieldHasNotes('documentation|stimInvoice') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'documentation|stimInvoice'" [notes]="getFilteredNotes('documentation|stimInvoice')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
        <br />
        <upload-view-files [uniqueId]="'stimInvoice'" [allowDeletion]="allowFileManipulation('stimInvoice')" [allowUpload]="allowFileManipulation('stimInvoice')" [files]="stimInvoiceFiles" [componentLabel]="''" [showFileList]="true" (fileRemoved)="stimInvoiceFileRemoved($event)" (newFilesList)="stimInvoiceFileAdded($event)"></upload-view-files>
      </div>
      <div class="cell small-12 medium-12 large-12 text-align-left">
        <span class="bold">Stimulation Record:</span>
        @if (fieldHasNotes('documentation|stimRecord') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'documentation|stimRecord'" [notes]="getFilteredNotes('documentation|stimRecord')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
        <br />
        <upload-view-files [uniqueId]="'stimRecord'" [allowDeletion]="allowFileManipulation('stimRecord')" [allowUpload]="allowFileManipulation('stimRecord')" [files]="stimRecordFiles" [componentLabel]="''" [showFileList]="true" (fileRemoved)="stimRecordFileRemoved($event)" (newFilesList)="stimRecordFileAdded($event)"></upload-view-files>
      </div>
      <div class="cell small-12 medium-12 large-12 text-align-left">
        <span class="bold">Stimulation Log:</span>
        @if (fieldHasNotes('documentation|stimLog') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'documentation|stimLog'" [notes]="getFilteredNotes('documentation|stimLog')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
        <br />
        <upload-view-files [uniqueId]="'stimLog'" [files]="stimLogFiles" [componentLabel]="''" [showFileList]="true" [allowDeletion]="allowFileManipulation('stimLog')" [allowUpload]="allowFileManipulation('stimLog')" (fileRemoved)="stimLogFileRemoved($event)" (newFilesList)="stimLogFileAdded($event)"></upload-view-files>
      </div>
    }


  </div>
</ng-container>
